import { render, staticRenderFns } from "./orderLimit.vue?vue&type=template&id=e0baa686&scoped=true"
import script from "./orderLimit.vue?vue&type=script&lang=js"
export * from "./orderLimit.vue?vue&type=script&lang=js"
import style0 from "./orderLimit.vue?vue&type=style&index=0&id=e0baa686&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0baa686",
  null
  
)

export default component.exports